import { render, staticRenderFns } from "./Ripple-effect.vue?vue&type=template&id=32ea14b4"
import script from "./Ripple-effect.vue?vue&type=script&lang=js"
export * from "./Ripple-effect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports